/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuctionOptionDto } from '../../models/auction-option-dto';

export interface GetAuctionOptions$Params {
  'X-API-Version'?: string;
}

export function getAuctionOptions(http: HttpClient, rootUrl: string, params?: GetAuctionOptions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AuctionOptionDto>>> {
  const rb = new RequestBuilder(rootUrl, getAuctionOptions.PATH, 'get');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AuctionOptionDto>>;
    })
  );
}

getAuctionOptions.PATH = '/api/auctions/options';
